import { ListItemIcon, ListItemText, makeStyles, Menu, MenuItem } from '@material-ui/core';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';
import ArrowDropUp from '@material-ui/icons/ArrowDropUp';
import DeleteOutlineOutlined from '@material-ui/icons/DeleteOutlineOutlined';
import MailOutline from '@material-ui/icons/MailOutline';
import { useState, useEffect } from 'react';
import { MdCompare } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import {
  checkHaveCompareItems,
  removeAllCompareItems,
  setIsViewingCompare,
} from '../../../store/slices/compare';
import CompareEmailModal from '../CompareEmailModal';
import Button from '../../Button';

const useStyles = makeStyles(() => ({
  menu: {
    '& .MuiListItemText-primary': {
      fontFamily: 'var(--fontFamilyBody)',
    },
  },
}));

const CompareActionsDropdown = () => {
  const classes = useStyles();
  const doHaveCompare = useSelector(checkHaveCompareItems);
  const [anchorEl, setAnchorEl] = useState(null);
  const [doShowModal, setDoShowModal] = useState(false);
  const dispatch = useDispatch();

  const { travelAgency } = useSelector((store) => store.user);
  const compareSettings =
    (travelAgency && travelAgency.settings && travelAgency.settings.compareSettings) || {};
  const displayLabel = (compareSettings.DisplayName || 'compare').toLowerCase();

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClick = (event) => {
    if (anchorEl) handleClose();
    setAnchorEl(event.currentTarget);
  };

  const handleSendClick = () => {
    dispatch(setIsViewingCompare(true));
    setDoShowModal(true);
  };

  const handleResetClick = () => {
    handleClose();
    dispatch(removeAllCompareItems());
  };

  const handleCloseModal = () => {
    dispatch(setIsViewingCompare(false));
    setDoShowModal(false);
  };

  useEffect(() => {
    if (!doHaveCompare) {
      dispatch(setIsViewingCompare(false));
      setDoShowModal(false);
      setAnchorEl(null);
    }
  }, [dispatch, doHaveCompare]);

  if (!doHaveCompare) return <></>;

  return (
    <>
      <Button
        onClick={handleClick}
        variant={Button.buttonVariants.OUTLINE_WHITE_BG}
        className="py-2 px-3 text-base"
      >
        <>
          <MdCompare className="inline" /> {`Your ${displayLabel}`}{' '}
          {anchorEl ? (
            <ArrowDropUp className="opacity-50" />
          ) : (
            <ArrowDropDown className="opacity-50" />
          )}
        </>
      </Button>
      <Menu
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        id="compare-actions-dropdown-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        classes={{ paper: classes.menu }}
      >
        <MenuItem component="li">
          <ListItemIcon>
            <MailOutline />
          </ListItemIcon>
          <ListItemText primary="Preview and send" onClick={handleSendClick} />
        </MenuItem>
        <MenuItem component="li">
          <ListItemIcon>
            <DeleteOutlineOutlined />
          </ListItemIcon>
          <ListItemText primary="Reset" onClick={handleResetClick} />
        </MenuItem>
      </Menu>
      <CompareEmailModal doShow={doShowModal} onClose={handleCloseModal} />
    </>
  );
};

export default CompareActionsDropdown;
